import React, {Component} from 'react';
import ContactPersons from './ContactPersons';
import {fbgAccess, partnerAccess, allAccess} from '../../services/access/index';
import ChangelogContainer from './ChangelogContainer';
import DashboardTips from './../tips/DashboardTips';

const ChangeLog = allAccess(ChangelogContainer);
const ContactPersonsList = partnerAccess(ContactPersons);

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <DashboardTips/>
                <ContactPersonsList/>
                <ChangeLog />
            </div>
        );
    }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./web/src/components/dashboard/Dashboard.jsx